// Centralised Insights summary fetch — every drill-in under /insights/* uses
// this hook so they share one cached query keyed on the URL period params.
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useWorkspaceStore } from '@/stores/workspace';
import { useInsightsRange } from './useInsightsRange';
import type { InsightsSummaryResult } from '@/lib/insightsTypes';

export function useInsightsSummary() {
  const ws = useWorkspaceStore((s) => s.current);
  const { fromParam, toParam, userIdParam } = useInsightsRange();
  return useQuery({
    queryKey: ['insights', 'summary', ws?.id, fromParam, toParam, userIdParam],
    queryFn: () => {
      const qs = new URLSearchParams({ from: fromParam, to: toParam, compare: 'auto' });
      if (userIdParam) qs.set('user_id', userIdParam);
      return api.get<InsightsSummaryResult>(`/insights/summary?${qs.toString()}`);
    },
    enabled: !!ws,
    staleTime: 60 * 1000,
  });
}
